import { jwtDecode } from 'jwt-decode';

import { LocalStorageService } from 'api';

export const isValidToken = () => {
	const localStorageService = new LocalStorageService();

	const valid = true;
	const token = localStorageService.getAccessToken();

	if (!token) return false;

	const now = Date.now();
	const decoded = jwtDecode(token);

	if (now > decoded.exp * 1000) return false;

	return valid;
};
